"use client"

import { useState } from "react";
import styles from "../../styles/pages/Aboutus.module.scss"
import Link from 'next/link'
import Slider from "react-slick";
import Gallerymodal from "../Gallerymodal/Gallerymodal";
import Image from "next/image";

export default function AboutGallery({ galleryImages, galleryHeading }) {
    const [clickedImage, setClickedImage] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(null);

    const gallery_slider = {
        dots: false,
        infinite: false,
        arrows: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const handleClick = (item, index) => {
        setCurrentIndex(index);
        setClickedImage(item.bgImage)
    }

    return (
        <>
            <div className={styles.our_gallery}>
                <div className='container'>
                    <div className='common_title'>
                        <h2 className='text-center'>{galleryHeading}</h2>
                    </div>
                    <div className={styles.gallery_main}>
                        <Slider {...gallery_slider} className="single_room_slider">
                            {galleryImages.map((item, index) => (
                                <div className={styles.gallery_child} key={index} onClick={() => handleClick(item, index)}>
                                    <Image
                                     src={item.bgImage}
                                      fill 
                                        sizes="(max-width: 768px) 100vw, 50vw"
                                      alt={item.altTest}
                                       onClick={() => handleClick(item, index)} />
                                </div>
                            ))}
                        </Slider>
                        {clickedImage && (
                            <Gallerymodal
                                galleryImages={galleryImages}
                                currentIndex={currentIndex}
                                setClickedImage={setClickedImage}
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}
